export const simpleWorkPlanner = {
  name: "Simple Work Planner",
  excerpt: "Simple mobile task planner",
  image: "simpleLeadTracker.webp",
  localUrl: "simple-work-planner",
  url: "#",
  description: "Simple Work Planner is a stripped down TODO list app that lets users create tasks and plan out their week.",
  challenge: "We wanted this app to be dead simple to use, and provide a UI that only took a few mintues to setup. We wanted users to be able to quickly add tasks so that they coudl spend less time managing their work and more time actually working.",
  solution: "We deployed the app on IOS using Cordova and built the bones using Clojurescript and Reagent. It's available on IOS with future plans to release to Android.",
  tech: ["Reagent", "Clojurescript", "Cordova"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
